import React, { Component } from 'react'
import { Row, Col, Form, Input, Button, Modal, Image, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Redirect, Link } from "react-router-dom";

import '../../Styles/Global/auth.css';

const axios = require("axios").default;
const { Text } = Typography


/**
 *
 *
 * @class UpdatePassword
 * @extends {Component}
 */
class UpdatePassword extends Component {



    /**
     *Creates an instance of UpdatePassword.
     * @param {*} props
     * @memberof UpdatePassword
     */
    constructor(props) {
        super(props);
        this.state = {
            log: false,
            isAdmin: false,
            isLogged: false,

            isRecovery: false,
            isRecoveryLoading: false,
            redirect: false,
            loading: false,
            form: {}
        }
    }

    recoveryPassword = React.createRef();

    redirectTo = "/login"


    /**
     *
     *
     * @memberof UpdatePassword
     */
    async componentDidMount() {
        const { token, email } = this.props.match.params;
        if (token === undefined || email === undefined) {
            this.redirectTo = "/login";
            this.setState({ redirect: true })
        } else {
            await this.setState({
                form: { email, token }
            })
            this.recoveryPassword.current.resetFields();
        }
    }



    /**
     *
     *
     * @memberof UpdatePassword
     */
    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to={this.redirectTo} />;
        }
    };


    /**
     *
     *
     * @memberof UpdatePassword
     */
    onFinish = async values => {
        this.setState({ loading: true })
        axios.put('/password/recovery/update', values)
            .then(() => {
                this.to = '/login';
                this.setState({
                    redirect: true
                })

            })
            .catch((error) => {
                console.log(error.response)
                Modal.error({
                    title: "No fue posible actualizar.",
                    content: "El token es invalido o el correo no existe."
                })
            })
            .finally(() => this.setState({ loading: false }))
    };
    render() {
        return (
            <>
                {this.renderRedirect()}
                <Row className="update-password">
                    <Col xs={24} lg={10} className="update-password-panel">
                        <div className="update-password-content">
                            <div className="update-password-logo">
                                <Image src={'/images/logo-blue.png'} preview={false} />
                            </div>
                            <div className="login-header">
                                <h3 className="h3-title login-title">Nueva contraseña</h3>
                                <Text className="login-subtitle">Crea una contraseña segura para tu cuenta</Text>
                            </div>
                            <Form
                                name="basic"
                                layout={"vertical"}
                                requiredMark={false}
                                className="login-form"
                                onFinish={this.onFinish}
                                initialValues={this.state.form}
                                ref={this.recoveryPassword}
                            >
                                <Form.Item name="token" noStyle >
                                    <Input type="hidden" />
                                </Form.Item>
                                <Form.Item
                                    label="Correo electrónico"
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: 'Para poder iniciar sesión, debe haber ingresado su correo electrónico'
                                    }]}
                                >
                                    <Input
                                        size="large"
                                        className="login-input"
                                        prefix={<MailOutlined className="login-input-icon" />}
                                        autoComplete="email"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="password"
                                    label="Nueva contraseña"
                                    extra="Mínimo 8 caracteres, con letras y números."
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor ingresa tu contraseña'
                                        },
                                        {
                                            min: 8,
                                            message: 'La contraseña debe de tener mínimo 8 caracteres'
                                        },
                                        {
                                            pattern: new RegExp("^(?=.*[0-9])(?=.*[a-z]|[A-Z]).+$"),
                                            message: 'Debe tener números y letras en mayusculas y minusculas'
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password
                                        size="large"
                                        placeholder="Nueva contraseña"
                                        className="login-input"
                                        prefix={<LockOutlined className="login-input-icon" />}
                                        autoComplete="new-password"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="confirm"
                                    label="Confirmar contraseña"
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, confirme su contraseña!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(rule, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Las contraseñas no coinciden.');
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        size="large"
                                        placeholder="Repite tu contraseña"
                                        className="login-input"
                                        prefix={<LockOutlined className="login-input-icon" />}
                                        autoComplete="new-password"
                                    />
                                </Form.Item>

                                <Form.Item style={{ marginBottom: 0 }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        size="large"
                                        className="button-login login-button"
                                        loading={this.state.loading}
                                    >
                                        Cambiar contraseña
                                    </Button>
                                </Form.Item>
                            </Form>
                            <div className="login-register update-password-back">
                                <Link to="/login" className="login-link">Volver a iniciar sesión</Link>
                            </div>
                        </div>
                    </Col>
                    <Col xs={0} lg={14} className="update-password-image" style={{ backgroundImage: "url('/images/bg-2.jpg')" }} />
                </Row>
            </>
        )
    }
}




export default UpdatePassword;